import { extractUriRoute } from "../../../utils";
import { ReduxAction } from "../../../typings";

export const ROUTE_PUSHED = "ROUTE_PUSHED";

export type RouterState = string;

const initialRoute = extractUriRoute(window.location.href) || "/";

export default function(
  state: RouterState = initialRoute,
  action: ReduxAction<any>,
): RouterState {
  switch (action.type) {
    case ROUTE_PUSHED:
      return action.payload;
    default:
      return state;
  }
}
